export const SURVEY_STATUSES = ["pending", "completed", "expired"] as const;
